import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import PropTypes from "prop-types";

import Colors from '../utils/colors';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: props => props.bgColor,
    color: props => props.color,
    padding: '0.5rem',
    marginBottom: '0.25rem'
  },
  role: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexGrow: 1,
    fontSize: '10px'
  },
  addCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '1.25rem',
  },

}));

export function MemberAddCard({ clickHandler}) {
  const classes = useStyles({bgColor: Colors.lightBlue, color: 'black'});
  return (
    <div className={classes.root} onClick={clickHandler}>
      <div className={classes.addCard}>
        <AddCircleOutlineIcon />
      </div>
    </div>
  );
}

export default function TeamMemberCard({  teamMember, }) {
  let bgColor = Colors.darkBlue;
  let color = 'white';

  const classes = useStyles({bgColor, color});

  return (
    <div className={classes.root} >
      {teamMember.name}
      <div className={classes.role}>
        { teamMember.role }
      </div>
    </div>
  );
}

TeamMemberCard.propTypes = {
  teamMember: PropTypes.object.isRequired,
};
